var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { alpha, Box, CardContent, Stack, Typography, useTheme } from "@mui/material";
import { CardWithShadow } from "@nitra/nkmb-card-components/cards";
import useIosContext from "@nitra/nkmb-card-components/contexts/IosContextProvider";
export function SupportStaffMobileCard(props) {
    var _a, _b;
    var _c = props.staff, firstName = _c.firstName, lastName = _c.lastName, image331x331url = _c.image331x331url;
    var theme = useTheme();
    var isIos = useIosContext().isIos;
    return (_jsx(CardWithShadow, __assign({ fixedWidth: 178, cardHeightOverride: 178, fullSizeImageUrl: image331x331url, fullSizeImageHideOverlay: true, disableOnHoverActions: true }, { children: _jsx(CardContent, { children: _jsxs(Stack, __assign({ sx: {
                    justifyContent: "flex-start",
                    alignItems: "center",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    height: 62,
                    position: "absolute",
                    color: theme.palette.text.primary,
                    backgroundColor: alpha(theme.palette.background.default, 0.9),
                } }, { children: [_jsx(Box, { sx: {
                            width: "100%",
                            backgroundColor: theme.palette.secondary.main,
                            position: "absolute",
                            bottom: 62,
                            height: "4px",
                        } }), _jsx(Typography, __assign({ variant: "h5", sx: (_a = {},
                            _a[theme.breakpoints.down("sm")] = isIos && {
                                '@media (-webkit-min-device-pixel-ratio: 2)': {
                                    fontWeight: 500, // Adjust font weight for iPhones
                                },
                            },
                            _a) }, { children: firstName })), _jsx(Typography, __assign({ variant: "h5", sx: (_b = {},
                            _b[theme.breakpoints.down("sm")] = isIos && {
                                '@media (-webkit-min-device-pixel-ratio: 2)': {
                                    fontWeight: 500, // Adjust font weight for iPhones
                                },
                            },
                            _b) }, { children: lastName }))] })) }) })));
}
